import { gql } from "@apollo/client";
import { PROGRAM_HISTORY_WITH_SPECIALIST } from "graphql-client/fragments";

export const GET_SINGLE_PLAYLIST = gql`
  query ($id: Int!) {
    playlist(id: $id) {
      id
      title
      isActive
      startOn
      endOn
      createdOn
      updatedOn
      deletedAt
      isFreeTrial
      isTracked

      account {
        id
        firstName
        lastName
        timeZone
      }
      program {
        id
        program_type
        round
      }

      playlistVoiceMessages {
        id
        order

        voiceMessage {
          id
          title
          feature
          focus
          templateLink
          cognitiveDomains
          createdOn
          audioFile {
            id
            durationInSeconds
          }
        }
      }
    }
  }
`;

export const UPDATE_SINGLE_PLAYLIST = gql`
  mutation (
    $id: Int!
    $title: String
    $voiceMessageIds: [Int!]
    $startOn: String
    $endOn: String
    $isFreeTrial: Boolean
    $isTracked: Boolean
    $programId: Int
  ) {
    updatePlaylist(
      data: {
        id: $id
        title: $title
        voiceMessageIds: $voiceMessageIds
        startOn: $startOn
        endOn: $endOn
        isFreeTrial: $isFreeTrial
        isTracked: $isTracked
        programId: $programId
      }
    ) {
      id
      title
      startOn
      endOn
      createdOn
      updatedOn
    }
  }
`;

export const DELETE_SINGLE_PLAYLIST = gql`
  mutation ($id: Int!) {
    deletePlaylist(id: $id) {
      id
      title
      startOn
      endOn
      createdOn
      updatedOn
    }
  }
`;

export const GET_TREATMENT_HISTORY = gql`
  query GetTreatmentHistory($accountId: Int!) {
    treatmentHistory: programHistory(account_id: $accountId) {
      ...ProgramHistoryWithSpecialist
    }
  }
  ${PROGRAM_HISTORY_WITH_SPECIALIST}
`;
